import { NgModule } from '@angular/core';
import { SharedModule } from './../../shared/sharedModule/sharedModule.module';
import { OAuthCheckComponent } from './oauthCheck.component';

@NgModule({
  imports: [SharedModule],
  declarations: [OAuthCheckComponent],
})
export class OAuthCheckModule {}
